























import MenuMixin from '@/mixins/menu-mixin';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import DoneTab1 from './done-tab1.vue';
import DoneTab2 from './done-tab2.vue';
import DoneTab3 from './done-tab3.vue';
import DoneTab4 from './done-tab4.vue';
@Component({
  components: { DoneTab1, DoneTab2, DoneTab3, DoneTab4 }
})
export default class Todo extends mixins(MenuMixin) {
  bread = [{ name: '我的工作台' }, { name: '我的已办' }];
  activeKey = 1;
}
